function renderMoneyman () {
  return `<div class="ui-form__row hidden">
    <div class="ui-form__field vali">
      <div class="ui-checkbox-directive">
        <span class="ui-blackhole">
          <input type="checkbox" name="moneyman1" id="moneyman1" readonly="" data-required disabled="">
        </span>
        <label for="moneyman1" class="ui-checkbox new-checkbox-label">
          <div class="ui-checkbox__check">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13" class="ui-icon-checkbox ui-checkbox__icon"><path stroke="#fff" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1 7s2.9 2.7 4.4 4c.4.3 1.1 1 1.1 1L16 1"></path></svg>
          </div>
          <span class="ui-checkbox__text-wrapper">Acepto los <a id="moneyman-contract" target="_blank">Condiciones Particulares de Contratación del Préstamo</a></span>
        </label>
      </div>
      <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">Tiene que aceptar las condiciones</div>
    </div>
    <div class="ui-form__field vali">
      <div class="ui-checkbox-directive">
        <span class="ui-blackhole">
          <input type="checkbox" name="moneyman2" id="moneyman2" readonly="" data-required disabled="">
        </span>
        <label for="moneyman2" class="ui-checkbox new-checkbox-label">
          <div class="ui-checkbox__check">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13" class="ui-icon-checkbox ui-checkbox__icon"><path stroke="#fff" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1 7s2.9 2.7 4.4 4c.4.3 1.1 1 1.1 1L16 1"></path></svg>
          </div>
          <span class="ui-checkbox__text-wrapper">Acepto los términos y condiciones y la <a href="https://www.moneyman.es/politica-de-privacidad/" target="_blank">política de privacidad</a></span>
        </label>
      </div>
      <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">Tiene que aceptar las condiciones</div>
    </div>
      <div class="ui-form__field vali">
        <div class="ui-checkbox-directive">
          <span class="ui-blackhole">
            <input type="checkbox" name="moneyman3" id="moneyman3" readonly="" data-required disabled="">
          </span>
          <label for="moneyman3" class="ui-checkbox new-checkbox-label">
            <div class="ui-checkbox__check">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 13" class="ui-icon-checkbox ui-checkbox__icon"><path stroke="#fff" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="M1 7s2.9 2.7 4.4 4c.4.3 1.1 1 1.1 1L16 1"></path></svg>
            </div>
            <span class="ui-checkbox__text-wrapper">Acepto recibir comunicaciones comerciales de Moneyman y terceros</span>
          </label>
        </div>
        <div class="ui-form-field-error-message ui-form-field-error-message_ui-form hidden">Tiene que aceptar las condiciones</div>
      </div>
    </div>`
}

export { renderMoneyman }